module.exports = __webpack_public_path__ + "img/4de517268f704d6a93687c2905b9cb27-640.6a32d79a.jpg";